module.exports = __webpack_public_path__ + "img/BuySell.0ad92372.png";